import { PickUpExportBody, PickUpFilters } from '../models';

export const PICKUP_EXPORT_MAX_DATE_RANGE_DAYS = 92;

const MS_PER_DAY = 86400000;

const hasRange = (from?: string, to?: string): boolean => !!from && !!to;

const rangeMessage = (
  label: string,
  from: string,
  to: string
): string | null => {
  const fromMs = new Date(from).getTime();
  const toMs = new Date(to).getTime();

  if (Number.isNaN(fromMs) || Number.isNaN(toMs)) {
    return `Las fechas de ${label} no son válidas.`;
  }
  if (fromMs > toMs) {
    return `En ${label}, la fecha desde debe ser anterior o igual a la fecha hasta.`;
  }
  if (toMs - fromMs > PICKUP_EXPORT_MAX_DATE_RANGE_DAYS * MS_PER_DAY) {
    return `El rango de ${label} no puede superar ${PICKUP_EXPORT_MAX_DATE_RANGE_DAYS} días.`;
  }

  return null;
};

export function getPickUpExportValidationMessage(
  filters: PickUpFilters
): string | null {
  const hasCreatedAt = hasRange(filters.createdAtFrom, filters.createdAtTo);
  const hasVisitedAt = hasRange(filters.visitedAtFrom, filters.visitedAtTo);

  if (!hasCreatedAt && !hasVisitedAt) {
    return 'Indicá un rango de fechas completo (desde y hasta) para exportar.';
  }

  if (hasCreatedAt) {
    const message = rangeMessage(
      'fecha de creación',
      filters.createdAtFrom!,
      filters.createdAtTo!
    );
    if (message) return message;
  }

  if (hasVisitedAt) {
    const message = rangeMessage(
      'fecha de retiro',
      filters.visitedAtFrom!,
      filters.visitedAtTo!
    );
    if (message) return message;
  }

  return null;
}

export function buildPickUpExportBody(filters: PickUpFilters): PickUpExportBody {
  const body: PickUpExportBody = {};

  if (filters.createdAtFrom && filters.createdAtTo) {
    body.createdAtFrom = filters.createdAtFrom;
    body.createdAtTo = filters.createdAtTo;
  }
  if (filters.visitedAtFrom && filters.visitedAtTo) {
    body.visitedAtFrom = filters.visitedAtFrom;
    body.visitedAtTo = filters.visitedAtTo;
  }
  if (filters.status) {
    body.status = filters.status;
  }
  if (filters.commerceId) {
    body.commerceId = filters.commerceId;
  }
  if (filters.driverId) {
    body.driverId = filters.driverId;
  }

  return body;
}
